import React, { useCallback } from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

const StyledTabs = styled(Tabs)({
  minHeight: '36px',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  minHeight: '36px',
  '&:hover': {
    color: theme.palette.primary.light,
    opacity: 1,
  },
  '&.Mui-selected': {
    color: theme.palette.grey[100],
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50px',
  },
}));

interface QuizTabsProps {
  currentTab: number;
  onSetCurrentTab: (tab: number) => void;
  firstTab: string;
  secondTab: string;
}

export const TabsComponent = React.memo(({ currentTab, onSetCurrentTab, firstTab, secondTab }: QuizTabsProps) => {
  const handleChange = useCallback(
    (event: React.SyntheticEvent, tab: number) => {
      onSetCurrentTab(tab);
    },
    [onSetCurrentTab],
  );

  return (
    <Box display="flex" justifyContent="center">
      <Box
        sx={{
          bgcolor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.800'),
          border: '1px solid',
          borderColor: (theme) => (theme.palette.mode === 'light' ? 'grey.300' : 'grey.700'),
          borderRadius: '50px',
          boxShadow: (theme) => theme.customShadows.boxShadow,
          p: 2,
        }}
      >
        <StyledTabs value={currentTab} onChange={handleChange}>
          <StyledTab disableRipple label={firstTab} />
          <StyledTab disableRipple label={secondTab} />
        </StyledTabs>
      </Box>
    </Box>
  );
});
